import { render, staticRenderFns } from "./PatientProfileModal.vue?vue&type=template&id=496c9a1a&"
import script from "./PatientProfileModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PatientProfileModal.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496c9a1a')) {
      api.createRecord('496c9a1a', component.options)
    } else {
      api.reload('496c9a1a', component.options)
    }
    module.hot.accept("./PatientProfileModal.vue?vue&type=template&id=496c9a1a&", function () {
      api.rerender('496c9a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/PatientProfile/PatientProfileModal.vue"
export default component.exports